module.exports = __webpack_public_path__ + "static/tourist_1_sff_desk-8939654112c8e801afbc47113b98f39b.jpg";